module.exports = __webpack_public_path__ + "static/img/map-bg.86a7d933.jpg";